import { Component, OnInit } from '@angular/core';
import { GeneratorService } from '../generator.service';

@Component({
  selector: 'cygov-generator-sub-entity-settings',
  templateUrl: './sub-entity-settings.component.html',
  styleUrls: ['./sub-entity-settings.component.scss']
})
export class SubEntitySettingsComponent implements OnInit {

  constructor(
    public service: GeneratorService,
  ) { }

  ngOnInit() {
  }

}
